// Kept dependency-free and separate from the help elements so the routing
// mixin can suggest a help page without pulling the whole help module graph
// into every route element (same split as elements/assistant/chat-layout.ts).
let suggestedHelpPage: string | undefined;

export function setSuggestedHelpPage(page: string | undefined) {
    suggestedHelpPage = page;
}

export function getSuggestedHelpPage() {
    return suggestedHelpPage;
}
